import { Brand, Panel, primary } from './ExperienceLayout';

export default function LocationScreen({ location, gps, onStart, onLocate, onBack }) {
  const isTolucaOnly = typeof location === 'string' && location.trim().toLowerCase() === 'toluca';
  const locationTitle = !location ? null : isTolucaOnly ? 'Toluca' : `Toluca - ${location}`;
  const hasGpsLocation = gps?.status === 'inside';

  let gpsDetail = null;
  if (hasGpsLocation && gps.label) {
    const distance = Number.isFinite(gps.distanceKm) ? ` · a ${gps.distanceKm} km del centro` : '';
    const accuracy = gps.accuracyM != null ? ` · precisión ±${gps.accuracyM} m` : '';
    gpsDetail = `📍 ${gps.label}${distance}${accuracy}`;
  } else if (gps?.status === 'outside') {
    const nearest = gps.nearestLabel ? ` · más cercana: ${gps.nearestLabel} a ${gps.nearestDistanceKm} km` : '';
    gpsDetail = `📍 Fuera de las 5 zonas${nearest}`;
  } else if (gps?.status === 'locating') {
    gpsDetail = '📍 Localizando por GPS…';
  } else if (gps?.status === 'error' && gps.message) {
    gpsDetail = `Ubicación aproximada: ${gps.message}`;
  }

  return (
    <Panel>
      <Brand compact centered />
      <h1 className="mt-8 font-display text-4xl uppercase leading-none text-[#F7E04B]">Marca tu zona</h1>
      <p className="mt-5 text-sm leading-6 text-[#C5E6A0]">Usaremos tu ubicación únicamente para asignar el punto de Toluca de esta partida.</p>
      {location && (
        <div className="mt-7 border border-[#7EC54A]/55 bg-[#0A1A0F]/70 p-5 text-left">
          <p className="text-[10px] font-black uppercase tracking-[.18em] text-[#7EC54A]">
            {hasGpsLocation ? 'Punto localizado' : 'Zona aproximada'}
          </p>
          <p className="mt-2 font-display text-2xl uppercase text-white">{locationTitle}</p>
          {gpsDetail && <p className="mt-2 text-xs leading-5 text-[#C5E6A0]" role="status">{gpsDetail}</p>}
        </div>
      )}
      {!hasGpsLocation && (
        <div className="mt-4 border border-[#F7E04B]/55 bg-[#2b2410]/90 p-4 text-left" role="note">
          <p className="text-[10px] font-black uppercase tracking-[.16em] text-[#F7E04B]">GPS opcional</p>
          <p className="mt-2 text-xs leading-5 text-white">Puedes jugar sin compartir tu ubicación, pero no podrás obtener todas las medallas, incluidas las de ubicación y primera visita.</p>
        </div>
      )}
      <button onClick={() => onStart('solo')} className={`${primary} mt-5`}>
        {hasGpsLocation ? 'Maldecir' : 'Jugar sin GPS'}
      </button>
      {!hasGpsLocation && (
        <button
          onClick={() => onLocate?.()}
          disabled={gps?.status === 'locating'}
          className="mt-3 min-h-[44px] w-full text-xs font-bold uppercase tracking-wider text-[#F7E04B] underline underline-offset-4 disabled:opacity-60"
        >
          {gps?.status === 'locating' ? 'Localizando…' : 'Intentar activar mi ubicación'}
        </button>
      )}
      <button onClick={onBack} className="mt-7 block w-full text-xs uppercase tracking-widest text-[#7EC54A]">Volver</button>
    </Panel>
  );
}
